export default __webpack_public_path__ + "static/media/classonline.009b1789.jpg";